<ub-heading i18n>Login information</ub-heading>
<div class="list" *ngIf="credentials$ let credentials">
  <eas-user-credential *ngFor="let cred of credentials" [credential]="cred"></eas-user-credential>
</div>
